export default class StepModel {
  constructor(step) {
    this.step = step;
  }

  get id() {
    return this.step.id;
  }

  get kind() {
    return this.step.kind;
  }

  get label() {
    return `${this.position + 1} - ${this.normalizedTitle()}`;
  }

  get position() {
    return this.step.position;
  }

  get options() {
    return this.step.options;
  }

  get jumps() {
    return this.step.jumps;
  }

  get optionsIds() {
    return this.step.options.map(option => option.id);
  }

  get jumpOptionsIds() {
    return this.step.jumps
      .filter(jump => jump.options_ids !== null)
      .map(jump => jump.options_ids[0]);
  }

  isEmail() {
    return this.step.kind === 'email';
  }

  isThanks() {
    return this.step.kind === 'thanks';
  }

  isText() {
    return this.step.kind === 'text';
  }

  isRedirectEmailService() {
    return this.step.redirect_email_service;
  }

  normalizedTitle() {
    return this.step.sanitized_title.replace(/\n/g, ' ');
  }
}



/** WEBPACK FOOTER **
 ** ./src/helpers/fluxogram/models/step.js
 **/